import { put, takeLatest, select } from "redux-saga/effects";
import { appNotify, fetchDashboardActiveWorkflowTasks, setActiveWorkflowIsLoading, setDashboardActiveWorkflowTasks } from "../store/actions";
import { postWithToken } from "../api/network";
import { dashboardFilterSelector } from 'store/selectors';

export function* getDashboardActiveWorkflowTasksSaga() {
  yield takeLatest(fetchDashboardActiveWorkflowTasks, function* ({payload}) {
    try {
      yield put(setActiveWorkflowIsLoading(true));

      var filter = yield select(dashboardFilterSelector);
      const data = {
        channels: payload.channel,
        userIds: payload.selectedUsers,
        loadOptions: {
          select: ["UnderwriteStatus", "OpportunityStatus", "State"],
          remoteSelect: true,
          filter: filter,
          group: [
            { "selector": "OpportunityStatus", "desc": false, "isExpanded": false },
            { "selector": "UnderwriteStatus", "desc": false, "isExpanded": false },
            { "selector": "State", "desc": false, "isExpanded": false },
          ],
          groupSummary: [
            { "selector": "Latitude", summaryType: "avg" },
            { "selector": "Longitude", summaryType: "avg" },
          ]
        }
      }

      const dashboardTasks = [];
      const url = `/api/dashboard/getDashboardActiveWorkflowData`;
      yield postWithToken(url, data)
        .then(response => response.json())
        .then((data) => {
          data.data.forEach((group) => {
            group.items.forEach((item) => {
              item.items.forEach((state) => {
                  const task = {
                    opportunityStatus: group.key, 
                    underwriteStatus: item.key, 
                    state: state.key, 
                    opportunitiesCount: 
                    state.count, 
                    latitude: state.summary[0], 
                    longitude: state.summary[1]};
                  dashboardTasks.push(task);
                }) 
            }) 
          })
        });

      console.log(`${payload.channel} active workflow tasks: `, dashboardTasks);

      yield put(setDashboardActiveWorkflowTasks({dashboardActiveWorkflowTasks: dashboardTasks}));
      yield put(setActiveWorkflowIsLoading(false));
    } catch (error)  {
      yield put(appNotify(`Failed to fetch dashboard workflow tasks: ${error.message}`, 'error'));
      yield put(setActiveWorkflowIsLoading(false));
    }
  });
}
